export default function ({ route, redirect }) {
  if (route.params.profileId === 'undefined') {
    let path = route.fullPath
    let newPath = path.replace('undefined', 'no-profile-ready')
    return redirect(newPath)
  }
}
